import { Button } from '@material-ui/core';
import React from 'react';
import { SearchErrorProps } from './search-error-props';
import './search-error.scss';

/**
 * Displays an error message and a `try again` button.
 *
 * Clicking the button fires a callback to allow the errored request to be sent again.
 * @param props
 */
export const SearchError: React.FC<SearchErrorProps> = (props) => {
  const {
    size = 'large',
    retry,
  } = props;

  return (
    <div className={`sg-search-error ${size === 'large' ? 'sg-search-error--large' : 'sg-search-error--small'}`}>
      {size === 'large' && (
        <>
          <img
            src="/images/timeout.svg"
            alt="Search timeout"
          />
          <h5>Looks like we&apos;re a little slow today</h5>
          <p>Your search has timed out. Please click below to try again.</p>
          <Button
            onClick={retry}
          >
            Try again
          </Button>
        </>
      )}
      {size === 'small' && (
        <div className="text--bold">Your search has timed out. Please try again.</div>
      )}
    </div>
  );
};
